
export default [
  { path: '/kiosk',
    name: 'kiosk',
    component: () => import('./Kiosk'),
    children: [
      {
        path: '/kiosk/design',
        name: 'kioskDesign',
        component: () => import('./KioskDesign')
      },
      {
        path: '/kiosk/menu',
        name: 'kioskMenu',
        component: () => import('./kiosk-menu/KioskMenu')
      }
    ]
  }
]
